import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../lib/firebase';
import './GetAuth.css';
import { FaFileDownload } from 'react-icons/fa'; // Import the FontAwesome icons


const GetAuth = ({ onAuthSuccess }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // New loading state

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true when form is submitted
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      onAuthSuccess(userCredential.user);
    } catch (error) {
      setError('Failed to login. Please check your credentials and try again.');
      setLoading(false); // Reset loading state if there's an error
    }
  };

  const handleDownloadClick = (userId) => {
    navigate(`/download`); // Navigate to user detail page
  };


  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Admin Login</h2>
        <p>Admin Access and authentication required to continue.</p>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              className="form-control"
              placeholder='johndoe@email.com'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              className="form-control"
              placeholder='********'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button 
            type="submit" 
            className="btn btn-warning"
            disabled={loading} // Disable the button when loading is true
          >
            {loading ? 'loading ...' : 'Login'} {/* Display different text when loading */}
          </button>
        </form>
        <button 
            onClick={() => handleDownloadClick()}
            className="downloadBtn">
            Download Mobile App  <FaFileDownload className="reset" />
          </button>
      </div>
      
    </div>
  );
};

export default GetAuth;
